module.exports = __webpack_public_path__ + "static/media/box.60b9a7b8.png";